import { Button } from "@spz/ui/components/button";
import { DialogFooter } from "@spz/ui/components/dialog";
import { useTranslation } from "react-i18next";
import { useWorkflowFormContext } from "./workflow-form-context";

export interface WorkflowDialogFooterProps {
  onButtonClick?: (action: string) => void;
  className?: string;
}

export function WorkflowDialogFooter({
  onButtonClick,
  className,
}: WorkflowDialogFooterProps) {
  const formContext = useWorkflowFormContext();
  const { t } = useTranslation();

  return (
    <DialogFooter
      hint={t("workflow_complete_investigation_form_fields_footer")}
      className={className}
    >
      {formContext?.schema?.action?.buttons.map((btn) => (
        <Button
          key={btn.label_key}
          variant={btn.variant}
          onClick={() => {
            if (btn.type === "cancel") {
              onButtonClick?.("cancel");
            } else {
              onButtonClick?.(btn.action);
            }
          }}
          type={btn.type === "submit" ? "submit" : "button"}
          loading={formContext.isSubmitting && btn.type === "submit"}
        >
          {t(btn.label_key ?? "")}
        </Button>
      ))}
    </DialogFooter>
  );
}
